import React from 'react';

import classNames from 'classnames/bind';
import style from './DesktopMenu.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

const DesktopMenu = props => (
  <div className={ctx('desktop-menu')}>
    {props.items.map((item, idx) => (
      <Link
        to={item.link}
        key={idx}
        className={ctx('item', { 'item--isActive': item.key === props.active })}
      >
        {item.title}
      </Link>
    ))}
  </div>
);

export default DesktopMenu;
